












import Vue from 'vue';
import { UserStatus } from '..';
import Invited from './Invited.vue';

export default Vue.extend({
  components: { Invited },
  props: {
    userId: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isInvited(): boolean {
      return UserStatus.isInvited(this.value);
    },
    isActive(): boolean {
      return UserStatus.isActive(this.value);
    },
  },
});
